var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStep1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 100,
    viewBox: "0 0 57 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.3827 0.000244141H7.61705C3.92218 0.000244141 0.916016 3.00641 0.916016 6.70127V93.2992C0.916016 96.9941 3.92218 100 7.61705 100H49.3827C53.0775 100 56.0837 96.9941 56.0837 93.2992V6.70127C56.0837 3.00661 53.0775 0.000244141 49.3827 0.000244141ZM7.61705 3.09313H49.3827C51.372 3.09313 52.991 4.71194 52.991 6.70147V82.3715H4.00871V6.70127C4.00871 4.71194 5.62771 3.09313 7.61705 3.09313ZM25.6492 90.4128C25.6492 88.8354 26.9172 87.557 28.5049 87.557C30.0823 87.557 31.3503 88.8354 31.3503 90.4128C31.3503 91.99 30.0823 93.2684 28.5049 93.2684C26.9172 93.2684 25.6492 91.99 25.6492 90.4128Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.602 11.34H21.396C20.5416 11.34 19.8496 10.6478 19.8496 9.79366C19.8496 8.93953 20.5418 8.24731 21.396 8.24731H35.602C36.4563 8.24731 37.1483 8.93953 37.1483 9.79366C37.1483 10.6478 36.4563 11.34 35.602 11.34Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4999 30.0413C21.1391 30.0413 15.1494 36.0309 15.1494 43.3918C15.1494 50.7526 21.1391 56.7423 28.4999 56.7423C35.8607 56.7423 41.8504 50.7526 41.8504 43.3918C41.8504 36.0309 35.8607 30.0413 28.4999 30.0413ZM33.8841 41.4204L27.754 47.5505C27.1499 48.1546 26.1713 48.1546 25.5674 47.5505L23.1159 45.0994C22.5118 44.4959 22.5118 43.5168 23.1159 42.9128C23.7191 42.3087 24.6986 42.3087 25.3025 42.9128L26.6606 44.2705L31.6975 39.2336C32.3016 38.6295 33.2802 38.6295 33.8841 39.2336C34.4882 39.8371 34.4882 40.8169 33.8841 41.4204Z",
    fill: "#2DCBE0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep1);
export default __webpack_public_path__ + "static/media/step1.e7022ce308a00baa43c42d3ca15444b6.svg";
export { ForwardRef as ReactComponent };